export default function IconWorkgroupAction () {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect width="24" height="24" rx="6" fill="#F3F6F8"/>
      <path fillRule="evenodd" clipRule="evenodd"
            d="M8.65919 10.017C8.88277 9.9689 9.1102 10.0247 9.28941 10.1629L9.30264 10.1731L9.35998 10.2237L11.9998 12.8789L14.6283 10.2352C14.7855 10.077 15.0005 9.9866 15.2307 10.0016C15.4583 10.0165 15.6553 10.1313 15.7903 10.2964L15.7998 10.3081L15.8441 10.3694L15.8519 10.3817C16.0644 10.7157 16.047 11.1724 15.8055 11.4846L15.7961 11.4967L15.746 11.5538L12.5531 14.7649C12.2759 15.0438 11.848 15.083 11.529 14.8377L11.5157 14.8274L11.458 14.7765L8.26469 11.5649C7.95087 11.2493 7.92159 10.7371 8.14773 10.3817C8.26118 10.2034 8.43865 10.0644 8.65919 10.017Z"
            fill="#85929A"/>
    </svg>
  )
}
